/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ImportWorkOrderDrawingAssignmentDto,
  JobCardRowDto,
  PartnerWorkOrderRowDto,
  ReorderManufacturingSequenceDto,
  ReorderManufacturingSequenceResponseDto,
  SetRouteRequestDto,
  SetRouteResponseDto,
  TagMigrationEnqueuedResponseDto,
  UpdateWorkOrdersDrawingsDto,
  WatchtowerUpdateWorkOrdersDto,
  WorkOrderDetailDto,
  WorkOrderDrawingRowDto,
  WorkOrderDrawingUploadDto,
  WorkOrderImportResultDto,
  WorkOrderImportValidationDto,
  WorkOrderStatusTransitionDto,
  WorkOrderStatusTransitionResponseDto,
  WorkOrdersControllerGetWorkOrderProgressParams
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type workOrdersControllerWatchtowerUpdateWorkOrdersResponse201 = {
  data: void
  status: 201
}

export type workOrdersControllerWatchtowerUpdateWorkOrdersResponseSuccess = (workOrdersControllerWatchtowerUpdateWorkOrdersResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerWatchtowerUpdateWorkOrdersResponse = (workOrdersControllerWatchtowerUpdateWorkOrdersResponseSuccess)

export const getWorkOrdersControllerWatchtowerUpdateWorkOrdersUrl = () => {




  return `/work-orders/watchtower-update`
}

export const workOrdersControllerWatchtowerUpdateWorkOrders = async (watchtowerUpdateWorkOrdersDto: WatchtowerUpdateWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerWatchtowerUpdateWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerWatchtowerUpdateWorkOrdersResponse>(getWorkOrdersControllerWatchtowerUpdateWorkOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(watchtowerUpdateWorkOrdersDto)
  }
);}





export const getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationKey = () => ['workOrdersControllerWatchtowerUpdateWorkOrders'] as const;

export const getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerWatchtowerUpdateWorkOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>>
    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationBody = WatchtowerUpdateWorkOrdersDto
    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationError = unknown
    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables = {data: WatchtowerUpdateWorkOrdersDto}

    export const useWorkOrdersControllerWatchtowerUpdateWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>,
        TError,
        WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationOptions(options), queryClient);
    }
    export type workOrdersControllerUpdateDrawingsResponse201 = {
  data: void
  status: 201
}

export type workOrdersControllerUpdateDrawingsResponseSuccess = (workOrdersControllerUpdateDrawingsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerUpdateDrawingsResponse = (workOrdersControllerUpdateDrawingsResponseSuccess)

export const getWorkOrdersControllerUpdateDrawingsUrl = () => {




  return `/work-orders/update-drawings`
}

export const workOrdersControllerUpdateDrawings = async (updateWorkOrdersDrawingsDto: UpdateWorkOrdersDrawingsDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerUpdateDrawingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerUpdateDrawingsResponse>(getWorkOrdersControllerUpdateDrawingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkOrdersDrawingsDto)
  }
);}





export const getWorkOrdersControllerUpdateDrawingsMutationKey = () => ['workOrdersControllerUpdateDrawings'] as const;

export const getWorkOrdersControllerUpdateDrawingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,WorkOrdersControllerUpdateDrawingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,WorkOrdersControllerUpdateDrawingsMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerUpdateDrawingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, WorkOrdersControllerUpdateDrawingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerUpdateDrawings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUpdateDrawingsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>>
    export type WorkOrdersControllerUpdateDrawingsMutationBody = UpdateWorkOrdersDrawingsDto
    export type WorkOrdersControllerUpdateDrawingsMutationError = unknown
    export type WorkOrdersControllerUpdateDrawingsMutationVariables = {data: UpdateWorkOrdersDrawingsDto}

    export const useWorkOrdersControllerUpdateDrawings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,WorkOrdersControllerUpdateDrawingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>,
        TError,
        WorkOrdersControllerUpdateDrawingsMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerUpdateDrawingsMutationOptions(options), queryClient);
    }
    export type workOrdersControllerUpdateDrawingsRevisionsResponse201 = {
  data: void
  status: 201
}

export type workOrdersControllerUpdateDrawingsRevisionsResponseSuccess = (workOrdersControllerUpdateDrawingsRevisionsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerUpdateDrawingsRevisionsResponse = (workOrdersControllerUpdateDrawingsRevisionsResponseSuccess)

export const getWorkOrdersControllerUpdateDrawingsRevisionsUrl = () => {




  return `/work-orders/update-drawings-revisions`
}

export const workOrdersControllerUpdateDrawingsRevisions = async (updateWorkOrdersDrawingsDto: UpdateWorkOrdersDrawingsDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerUpdateDrawingsRevisionsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerUpdateDrawingsRevisionsResponse>(getWorkOrdersControllerUpdateDrawingsRevisionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkOrdersDrawingsDto)
  }
);}





export const getWorkOrdersControllerUpdateDrawingsRevisionsMutationKey = () => ['workOrdersControllerUpdateDrawingsRevisions'] as const;

export const getWorkOrdersControllerUpdateDrawingsRevisionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerUpdateDrawingsRevisionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerUpdateDrawingsRevisions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>>
    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationBody = UpdateWorkOrdersDrawingsDto
    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationError = unknown
    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables = {data: UpdateWorkOrdersDrawingsDto}

    export const useWorkOrdersControllerUpdateDrawingsRevisions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>,
        TError,
        WorkOrdersControllerUpdateDrawingsRevisionsMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerUpdateDrawingsRevisionsMutationOptions(options), queryClient);
    }
    export type workOrdersControllerImportDrawingsResponse201 = {
  data: void
  status: 201
}

export type workOrdersControllerImportDrawingsResponseSuccess = (workOrdersControllerImportDrawingsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerImportDrawingsResponse = (workOrdersControllerImportDrawingsResponseSuccess)

export const getWorkOrdersControllerImportDrawingsUrl = () => {




  return `/work-orders/import-drawings`
}

export const workOrdersControllerImportDrawings = async (importWorkOrderDrawingAssignmentDto: ImportWorkOrderDrawingAssignmentDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerImportDrawingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerImportDrawingsResponse>(getWorkOrdersControllerImportDrawingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(importWorkOrderDrawingAssignmentDto)
  }
);}





export const getWorkOrdersControllerImportDrawingsMutationKey = () => ['workOrdersControllerImportDrawings'] as const;

export const getWorkOrdersControllerImportDrawingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,WorkOrdersControllerImportDrawingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,WorkOrdersControllerImportDrawingsMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerImportDrawingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, WorkOrdersControllerImportDrawingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerImportDrawings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerImportDrawingsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>>
    export type WorkOrdersControllerImportDrawingsMutationBody = ImportWorkOrderDrawingAssignmentDto
    export type WorkOrdersControllerImportDrawingsMutationError = unknown
    export type WorkOrdersControllerImportDrawingsMutationVariables = {data: ImportWorkOrderDrawingAssignmentDto}

    export const useWorkOrdersControllerImportDrawings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,WorkOrdersControllerImportDrawingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>,
        TError,
        WorkOrdersControllerImportDrawingsMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerImportDrawingsMutationOptions(options), queryClient);
    }
    export type workOrdersControllerImportWorkOrdersResponse201 = {
  data: WorkOrderImportResultDto
  status: 201
}

export type workOrdersControllerImportWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type workOrdersControllerImportWorkOrdersResponse403 = {
  data: void
  status: 403
}

export type workOrdersControllerImportWorkOrdersResponseSuccess = (workOrdersControllerImportWorkOrdersResponse201) & {
  headers: Headers;
};
export type workOrdersControllerImportWorkOrdersResponseError = (workOrdersControllerImportWorkOrdersResponse401 | workOrdersControllerImportWorkOrdersResponse403) & {
  headers: Headers;
};

export type workOrdersControllerImportWorkOrdersResponse = (workOrdersControllerImportWorkOrdersResponseSuccess | workOrdersControllerImportWorkOrdersResponseError)

export const getWorkOrdersControllerImportWorkOrdersUrl = () => {




  return `/work-orders/import`
}

/**
 * Creates missing tag categories and tags, updates existing work orders, and creates new ones. Rows the import cannot safely apply — an unresolvable Run Sheet, or a Run Sheet belonging to a different product than the work order — are skipped and returned in `skippedWorkOrders` rather than failing the whole request.
 * @summary Import work orders for a partner
 */
export const workOrdersControllerImportWorkOrders = async (workOrderImportValidationDto: WorkOrderImportValidationDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerImportWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerImportWorkOrdersResponse>(getWorkOrdersControllerImportWorkOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrderImportValidationDto)
  }
);}





export const getWorkOrdersControllerImportWorkOrdersMutationKey = () => ['workOrdersControllerImportWorkOrders'] as const;

export const getWorkOrdersControllerImportWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,WorkOrdersControllerImportWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,WorkOrdersControllerImportWorkOrdersMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerImportWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, WorkOrdersControllerImportWorkOrdersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerImportWorkOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerImportWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>>
    export type WorkOrdersControllerImportWorkOrdersMutationBody = WorkOrderImportValidationDto
    export type WorkOrdersControllerImportWorkOrdersMutationError = void
    export type WorkOrdersControllerImportWorkOrdersMutationVariables = {data: WorkOrderImportValidationDto}

    /**
 * @summary Import work orders for a partner
 */
export const useWorkOrdersControllerImportWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,WorkOrdersControllerImportWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>,
        TError,
        WorkOrdersControllerImportWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerImportWorkOrdersMutationOptions(options), queryClient);
    }
    export type workOrdersControllerMigrateWorkOrderTagsResponse202 = {
  data: TagMigrationEnqueuedResponseDto
  status: 202
}

export type workOrdersControllerMigrateWorkOrderTagsResponse401 = {
  data: void
  status: 401
}

export type workOrdersControllerMigrateWorkOrderTagsResponse403 = {
  data: void
  status: 403
}

export type workOrdersControllerMigrateWorkOrderTagsResponseSuccess = (workOrdersControllerMigrateWorkOrderTagsResponse202) & {
  headers: Headers;
};
export type workOrdersControllerMigrateWorkOrderTagsResponseError = (workOrdersControllerMigrateWorkOrderTagsResponse401 | workOrdersControllerMigrateWorkOrderTagsResponse403) & {
  headers: Headers;
};

export type workOrdersControllerMigrateWorkOrderTagsResponse = (workOrdersControllerMigrateWorkOrderTagsResponseSuccess | workOrdersControllerMigrateWorkOrderTagsResponseError)

export const getWorkOrdersControllerMigrateWorkOrderTagsUrl = (workOrderId: string,) => {




  return `/work-orders/${workOrderId}/migrate-tags`
}

/**
 * Enqueues a background job that copies this work order’s legacy Tag values into Custom Columns (push-only: set/overwritten from the tag, never cleared). A no-op when the work order’s partner has no configured mapping or the target custom column does not exist yet.
 * @summary Backfill custom columns from legacy tags for one work order
 */
export const workOrdersControllerMigrateWorkOrderTags = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerMigrateWorkOrderTagsResponse> => {

  return customFetch<workOrdersControllerMigrateWorkOrderTagsResponse>(getWorkOrdersControllerMigrateWorkOrderTagsUrl(workOrderId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWorkOrdersControllerMigrateWorkOrderTagsMutationKey = () => ['workOrdersControllerMigrateWorkOrderTags'] as const;

export const getWorkOrdersControllerMigrateWorkOrderTagsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,WorkOrdersControllerMigrateWorkOrderTagsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,WorkOrdersControllerMigrateWorkOrderTagsMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerMigrateWorkOrderTagsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, WorkOrdersControllerMigrateWorkOrderTagsMutationVariables> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerMigrateWorkOrderTags(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerMigrateWorkOrderTagsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>>

    export type WorkOrdersControllerMigrateWorkOrderTagsMutationError = void
    export type WorkOrdersControllerMigrateWorkOrderTagsMutationVariables = {workOrderId: string}

    /**
 * @summary Backfill custom columns from legacy tags for one work order
 */
export const useWorkOrdersControllerMigrateWorkOrderTags = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,WorkOrdersControllerMigrateWorkOrderTagsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>,
        TError,
        WorkOrdersControllerMigrateWorkOrderTagsMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerMigrateWorkOrderTagsMutationOptions(options), queryClient);
    }
    export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponse201 = {
  data: void
  status: 201
}

export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponseSuccess = (workOrdersControllerRemoveDrawingsFromWorkOrdersResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponse = (workOrdersControllerRemoveDrawingsFromWorkOrdersResponseSuccess)

export const getWorkOrdersControllerRemoveDrawingsFromWorkOrdersUrl = () => {




  return `/work-orders/remove-drawings`
}

export const workOrdersControllerRemoveDrawingsFromWorkOrders = async (workOrdersControllerRemoveDrawingsFromWorkOrdersBody: string[], options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerRemoveDrawingsFromWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersControllerRemoveDrawingsFromWorkOrdersResponse>(getWorkOrdersControllerRemoveDrawingsFromWorkOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrdersControllerRemoveDrawingsFromWorkOrdersBody)
  }
);}





export const getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationKey = () => ['workOrdersControllerRemoveDrawingsFromWorkOrders'] as const;

export const getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerRemoveDrawingsFromWorkOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>>
    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationBody = string[]
    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationError = unknown
    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables = {data: string[]}

    export const useWorkOrdersControllerRemoveDrawingsFromWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>,
        TError,
        WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationOptions(options), queryClient);
    }
    export type workOrdersControllerArchiveWorkOrderResponse200 = {
  data: void
  status: 200
}

export type workOrdersControllerArchiveWorkOrderResponseSuccess = (workOrdersControllerArchiveWorkOrderResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerArchiveWorkOrderResponse = (workOrdersControllerArchiveWorkOrderResponseSuccess)

export const getWorkOrdersControllerArchiveWorkOrderUrl = (workOrderId: string,) => {




  return `/work-orders/archive/${workOrderId}`
}

export const workOrdersControllerArchiveWorkOrder = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerArchiveWorkOrderResponse> => {

  return customFetch<workOrdersControllerArchiveWorkOrderResponse>(getWorkOrdersControllerArchiveWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getWorkOrdersControllerArchiveWorkOrderMutationKey = () => ['workOrdersControllerArchiveWorkOrder'] as const;

export const getWorkOrdersControllerArchiveWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,WorkOrdersControllerArchiveWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,WorkOrdersControllerArchiveWorkOrderMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerArchiveWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, WorkOrdersControllerArchiveWorkOrderMutationVariables> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerArchiveWorkOrder(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerArchiveWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>>

    export type WorkOrdersControllerArchiveWorkOrderMutationError = unknown
    export type WorkOrdersControllerArchiveWorkOrderMutationVariables = {workOrderId: string}

    export const useWorkOrdersControllerArchiveWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,WorkOrdersControllerArchiveWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>,
        TError,
        WorkOrdersControllerArchiveWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerArchiveWorkOrderMutationOptions(options), queryClient);
    }
    export type workOrdersControllerBulkArchiveWorkOrdersResponse200 = {
  data: void
  status: 200
}

export type workOrdersControllerBulkArchiveWorkOrdersResponseSuccess = (workOrdersControllerBulkArchiveWorkOrdersResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerBulkArchiveWorkOrdersResponse = (workOrdersControllerBulkArchiveWorkOrdersResponseSuccess)

export const getWorkOrdersControllerBulkArchiveWorkOrdersUrl = () => {




  return `/work-orders/bulk-archive`
}

export const workOrdersControllerBulkArchiveWorkOrders = async ( options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerBulkArchiveWorkOrdersResponse> => {

  return customFetch<workOrdersControllerBulkArchiveWorkOrdersResponse>(getWorkOrdersControllerBulkArchiveWorkOrdersUrl(),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getWorkOrdersControllerBulkArchiveWorkOrdersMutationKey = () => ['workOrdersControllerBulkArchiveWorkOrders'] as const;

export const getWorkOrdersControllerBulkArchiveWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext> => {

const mutationKey = getWorkOrdersControllerBulkArchiveWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, void> = () => {


          return  workOrdersControllerBulkArchiveWorkOrders(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerBulkArchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>>

    export type WorkOrdersControllerBulkArchiveWorkOrdersMutationError = unknown


    export const useWorkOrdersControllerBulkArchiveWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerBulkArchiveWorkOrdersMutationOptions(options), queryClient);
    }
    export type workOrdersControllerUnarchiveWorkOrderResponse200 = {
  data: void
  status: 200
}

export type workOrdersControllerUnarchiveWorkOrderResponseSuccess = (workOrdersControllerUnarchiveWorkOrderResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerUnarchiveWorkOrderResponse = (workOrdersControllerUnarchiveWorkOrderResponseSuccess)

export const getWorkOrdersControllerUnarchiveWorkOrderUrl = (workOrderId: string,) => {




  return `/work-orders/unarchive/${workOrderId}`
}

export const workOrdersControllerUnarchiveWorkOrder = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerUnarchiveWorkOrderResponse> => {

  return customFetch<workOrdersControllerUnarchiveWorkOrderResponse>(getWorkOrdersControllerUnarchiveWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getWorkOrdersControllerUnarchiveWorkOrderMutationKey = () => ['workOrdersControllerUnarchiveWorkOrder'] as const;

export const getWorkOrdersControllerUnarchiveWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,WorkOrdersControllerUnarchiveWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,WorkOrdersControllerUnarchiveWorkOrderMutationVariables, TContext> => {

const mutationKey = getWorkOrdersControllerUnarchiveWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, WorkOrdersControllerUnarchiveWorkOrderMutationVariables> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerUnarchiveWorkOrder(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUnarchiveWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>>

    export type WorkOrdersControllerUnarchiveWorkOrderMutationError = unknown
    export type WorkOrdersControllerUnarchiveWorkOrderMutationVariables = {workOrderId: string}

    export const useWorkOrdersControllerUnarchiveWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,WorkOrdersControllerUnarchiveWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>,
        TError,
        WorkOrdersControllerUnarchiveWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersControllerUnarchiveWorkOrderMutationOptions(options), queryClient);
    }
    export type workOrdersControllerGetWorkOrderProgressResponse200 = {
  data: void
  status: 200
}

export type workOrdersControllerGetWorkOrderProgressResponseSuccess = (workOrdersControllerGetWorkOrderProgressResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerGetWorkOrderProgressResponse = (workOrdersControllerGetWorkOrderProgressResponseSuccess)

export const getWorkOrdersControllerGetWorkOrderProgressUrl = (partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/work-orders/progress/${partnerName}?${stringifiedParams}` : `/work-orders/progress/${partnerName}`
}

export const workOrdersControllerGetWorkOrderProgress = async (partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersControllerGetWorkOrderProgressResponse> => {

  return customFetch<workOrdersControllerGetWorkOrderProgressResponse>(getWorkOrdersControllerGetWorkOrderProgressUrl(partnerName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkOrdersControllerGetWorkOrderProgressQueryKey = (partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams,) => {
    return [
    `/work-orders/progress/${partnerName}`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkOrdersControllerGetWorkOrderProgressQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersControllerGetWorkOrderProgressQueryKey(partnerName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>> = ({ signal }) => workOrdersControllerGetWorkOrderProgress(partnerName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerName !== null && partnerName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersControllerGetWorkOrderProgressQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>>
export type WorkOrdersControllerGetWorkOrderProgressQueryError = unknown


export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params: undefined |  WorkOrdersControllerGetWorkOrderProgressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressQueryOptions(partnerName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchWorkOrdersControllerGetWorkOrderProgressQuery = async <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 queryClient: QueryClient, partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressQueryOptions(partnerName,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkOrdersControllerGetWorkOrderProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersControllerGetWorkOrderProgressQueryKey(partnerName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>> = ({ signal }) => workOrdersControllerGetWorkOrderProgress(partnerName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersControllerGetWorkOrderProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>>
export type WorkOrdersControllerGetWorkOrderProgressSuspenseQueryError = unknown


export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params: undefined |  WorkOrdersControllerGetWorkOrderProgressParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressSuspenseQueryOptions(partnerName,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workOrdersPartnerControllerListPartnerWorkOrdersResponse200 = {
  data: PartnerWorkOrderRowDto[]
  status: 200
}

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerListPartnerWorkOrdersResponseSuccess = (workOrdersPartnerControllerListPartnerWorkOrdersResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerListPartnerWorkOrdersResponseError = (workOrdersPartnerControllerListPartnerWorkOrdersResponse401 | workOrdersPartnerControllerListPartnerWorkOrdersResponse403) & {
  headers: Headers;
};

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse = (workOrdersPartnerControllerListPartnerWorkOrdersResponseSuccess | workOrdersPartnerControllerListPartnerWorkOrdersResponseError)

export const getWorkOrdersPartnerControllerListPartnerWorkOrdersUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/work-orders`
}

/**
 * Returns every non-archived work order for the partner with the same enriched shape the project planning grid uses (project / factory / product / container_selections / metadata).
 * @summary List all work orders for a partner
 */
export const workOrdersPartnerControllerListPartnerWorkOrders = async (partnerId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerListPartnerWorkOrdersResponse> => {

  return customFetch<workOrdersPartnerControllerListPartnerWorkOrdersResponse>(getWorkOrdersPartnerControllerListPartnerWorkOrdersUrl(partnerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey = (partnerId: string,) => {
    return [
    `/partners/${partnerId}/work-orders`
    ] as const;
    }


export const getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>> = ({ signal }) => workOrdersPartnerControllerListPartnerWorkOrders(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListPartnerWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>>
export type WorkOrdersPartnerControllerListPartnerWorkOrdersQueryError = void


export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all work orders for a partner
 */

export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List all work orders for a partner
 */
export const prefetchWorkOrdersPartnerControllerListPartnerWorkOrdersQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>> = ({ signal }) => workOrdersPartnerControllerListPartnerWorkOrders(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>>
export type WorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryError = void


export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all work orders for a partner
 */

export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workOrdersPartnerControllerReopenForEditResponse201 = {
  data: WorkOrderStatusTransitionResponseDto
  status: 201
}

export type workOrdersPartnerControllerReopenForEditResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReopenForEditResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReopenForEditResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReopenForEditResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerReopenForEditResponseSuccess = (workOrdersPartnerControllerReopenForEditResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReopenForEditResponseError = (workOrdersPartnerControllerReopenForEditResponse400 | workOrdersPartnerControllerReopenForEditResponse401 | workOrdersPartnerControllerReopenForEditResponse403 | workOrdersPartnerControllerReopenForEditResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReopenForEditResponse = (workOrdersPartnerControllerReopenForEditResponseSuccess | workOrdersPartnerControllerReopenForEditResponseError)

export const getWorkOrdersPartnerControllerReopenForEditUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/work-orders/reopen-for-edit`
}

/**
 * Flips work_orders.is_redrafting = true for every supplied work_order_id that currently belongs to the path partner and is in 'scheduled' or 'redrafting'. The trigger on work_orders recomputes work_order_current_status to 'redrafting'. Idempotent: ids already in 'redrafting' are reported in `unchanged` rather than treated as an error.
 * @summary Reopen released work orders for system-column edits
 */
export const workOrdersPartnerControllerReopenForEdit = async (partnerId: string,
    workOrderStatusTransitionDto: WorkOrderStatusTransitionDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerReopenForEditResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersPartnerControllerReopenForEditResponse>(getWorkOrdersPartnerControllerReopenForEditUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrderStatusTransitionDto)
  }
);}





export const getWorkOrdersPartnerControllerReopenForEditMutationKey = () => ['workOrdersPartnerControllerReopenForEdit'] as const;

export const getWorkOrdersPartnerControllerReopenForEditMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,WorkOrdersPartnerControllerReopenForEditMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,WorkOrdersPartnerControllerReopenForEditMutationVariables, TContext> => {

const mutationKey = getWorkOrdersPartnerControllerReopenForEditMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, WorkOrdersPartnerControllerReopenForEditMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReopenForEdit(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReopenForEditMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>>
    export type WorkOrdersPartnerControllerReopenForEditMutationBody = WorkOrderStatusTransitionDto
    export type WorkOrdersPartnerControllerReopenForEditMutationError = void
    export type WorkOrdersPartnerControllerReopenForEditMutationVariables = {partnerId: string;data: WorkOrderStatusTransitionDto}

    /**
 * @summary Reopen released work orders for system-column edits
 */
export const useWorkOrdersPartnerControllerReopenForEdit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,WorkOrdersPartnerControllerReopenForEditMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>,
        TError,
        WorkOrdersPartnerControllerReopenForEditMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersPartnerControllerReopenForEditMutationOptions(options), queryClient);
    }
    export type workOrdersPartnerControllerReReleaseResponse201 = {
  data: WorkOrderStatusTransitionResponseDto
  status: 201
}

export type workOrdersPartnerControllerReReleaseResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReReleaseResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReReleaseResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReReleaseResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerReReleaseResponseSuccess = (workOrdersPartnerControllerReReleaseResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReReleaseResponseError = (workOrdersPartnerControllerReReleaseResponse400 | workOrdersPartnerControllerReReleaseResponse401 | workOrdersPartnerControllerReReleaseResponse403 | workOrdersPartnerControllerReReleaseResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReReleaseResponse = (workOrdersPartnerControllerReReleaseResponseSuccess | workOrdersPartnerControllerReReleaseResponseError)

export const getWorkOrdersPartnerControllerReReleaseUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/work-orders/re-release`
}

/**
 * Flips work_orders.is_redrafting = false for every supplied work_order_id that currently belongs to the path partner and is in 'redrafting' or 'scheduled'. The trigger recomputes status back to 'scheduled'. Does NOT create or roll a Run Sheet version — that remains a separate flow under /change-control. Idempotent in the same way as reopen-for-edit.
 * @summary Re-release work orders previously reopened for edit
 */
export const workOrdersPartnerControllerReRelease = async (partnerId: string,
    workOrderStatusTransitionDto: WorkOrderStatusTransitionDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerReReleaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersPartnerControllerReReleaseResponse>(getWorkOrdersPartnerControllerReReleaseUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrderStatusTransitionDto)
  }
);}





export const getWorkOrdersPartnerControllerReReleaseMutationKey = () => ['workOrdersPartnerControllerReRelease'] as const;

export const getWorkOrdersPartnerControllerReReleaseMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,WorkOrdersPartnerControllerReReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,WorkOrdersPartnerControllerReReleaseMutationVariables, TContext> => {

const mutationKey = getWorkOrdersPartnerControllerReReleaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, WorkOrdersPartnerControllerReReleaseMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReRelease(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>>
    export type WorkOrdersPartnerControllerReReleaseMutationBody = WorkOrderStatusTransitionDto
    export type WorkOrdersPartnerControllerReReleaseMutationError = void
    export type WorkOrdersPartnerControllerReReleaseMutationVariables = {partnerId: string;data: WorkOrderStatusTransitionDto}

    /**
 * @summary Re-release work orders previously reopened for edit
 */
export const useWorkOrdersPartnerControllerReRelease = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,WorkOrdersPartnerControllerReReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>,
        TError,
        WorkOrdersPartnerControllerReReleaseMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersPartnerControllerReReleaseMutationOptions(options), queryClient);
    }
    export type workOrdersPartnerControllerReorderManufacturingSequenceResponse201 = {
  data: ReorderManufacturingSequenceResponseDto
  status: 201
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse409 = {
  data: void
  status: 409
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponseSuccess = (workOrdersPartnerControllerReorderManufacturingSequenceResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReorderManufacturingSequenceResponseError = (workOrdersPartnerControllerReorderManufacturingSequenceResponse400 | workOrdersPartnerControllerReorderManufacturingSequenceResponse401 | workOrdersPartnerControllerReorderManufacturingSequenceResponse403 | workOrdersPartnerControllerReorderManufacturingSequenceResponse404 | workOrdersPartnerControllerReorderManufacturingSequenceResponse409) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse = (workOrdersPartnerControllerReorderManufacturingSequenceResponseSuccess | workOrdersPartnerControllerReorderManufacturingSequenceResponseError)

export const getWorkOrdersPartnerControllerReorderManufacturingSequenceUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/work-orders/reorder-manufacturing-sequence`
}

/**
 * Moves the selected work orders within their Manufacturing Sequence Number running order. Every selected work order must belong to the path partner, be in a movable state (scheduled or redrafting), and share one running order: a single factory, or — for work orders without a factory — the partner-wide unassigned group. Started work (in_progress / complete) keeps its number and the movable run is renumbered contiguously after it; only rows whose number changes are written. Modes: by_number (the first selected work order lands on target_sequence_number), after / before (placed relative to the anchor, given as exactly one of anchor_work_order_name / anchor_work_order_id).
 * @summary Reorder the Manufacturing Sequence Number for one or more work orders
 */
export const workOrdersPartnerControllerReorderManufacturingSequence = async (partnerId: string,
    reorderManufacturingSequenceDto: ReorderManufacturingSequenceDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerReorderManufacturingSequenceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workOrdersPartnerControllerReorderManufacturingSequenceResponse>(getWorkOrdersPartnerControllerReorderManufacturingSequenceUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderManufacturingSequenceDto)
  }
);}





export const getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationKey = () => ['workOrdersPartnerControllerReorderManufacturingSequence'] as const;

export const getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables, TContext> => {

const mutationKey = getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReorderManufacturingSequence(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>>
    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationBody = ReorderManufacturingSequenceDto
    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationError = void
    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables = {partnerId: string;data: ReorderManufacturingSequenceDto}

    /**
 * @summary Reorder the Manufacturing Sequence Number for one or more work orders
 */
export const useWorkOrdersPartnerControllerReorderManufacturingSequence = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>,
        TError,
        WorkOrdersPartnerControllerReorderManufacturingSequenceMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationOptions(options), queryClient);
    }
    export type workOrdersPartnerControllerListJobCardsResponse200 = {
  data: JobCardRowDto[]
  status: 200
}

export type workOrdersPartnerControllerListJobCardsResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerListJobCardsResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerListJobCardsResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerListJobCardsResponseSuccess = (workOrdersPartnerControllerListJobCardsResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerListJobCardsResponseError = (workOrdersPartnerControllerListJobCardsResponse401 | workOrdersPartnerControllerListJobCardsResponse403 | workOrdersPartnerControllerListJobCardsResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerListJobCardsResponse = (workOrdersPartnerControllerListJobCardsResponseSuccess | workOrdersPartnerControllerListJobCardsResponseError)

export const getWorkOrdersPartnerControllerListJobCardsUrl = (workOrderId: string,) => {




  return `/work-orders/${workOrderId}/job-cards`
}

/**
 * Returns every job card materialised for the work order, ordered by job_card_order. Used by the Work Orders grid as a master/detail child table.
 * @summary List a work order's job cards
 */
export const workOrdersPartnerControllerListJobCards = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerListJobCardsResponse> => {

  return customFetch<workOrdersPartnerControllerListJobCardsResponse>(getWorkOrdersPartnerControllerListJobCardsUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkOrdersPartnerControllerListJobCardsQueryKey = (workOrderId: string,) => {
    return [
    `/work-orders/${workOrderId}/job-cards`
    ] as const;
    }


export const getWorkOrdersPartnerControllerListJobCardsQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListJobCardsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>> = ({ signal }) => workOrdersPartnerControllerListJobCards(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListJobCardsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>>
export type WorkOrdersPartnerControllerListJobCardsQueryError = void


export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a work order's job cards
 */

export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List a work order's job cards
 */
export const prefetchWorkOrdersPartnerControllerListJobCardsQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 queryClient: QueryClient, workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsQueryOptions(workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkOrdersPartnerControllerListJobCardsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListJobCardsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>> = ({ signal }) => workOrdersPartnerControllerListJobCards(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListJobCardsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>>
export type WorkOrdersPartnerControllerListJobCardsSuspenseQueryError = void


export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a work order's job cards
 */

export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workOrdersPartnerControllerGetWorkOrderDetailResponse200 = {
  data: WorkOrderDetailDto
  status: 200
}

export type workOrdersPartnerControllerGetWorkOrderDetailResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerGetWorkOrderDetailResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerGetWorkOrderDetailResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerGetWorkOrderDetailResponseSuccess = (workOrdersPartnerControllerGetWorkOrderDetailResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerGetWorkOrderDetailResponseError = (workOrdersPartnerControllerGetWorkOrderDetailResponse401 | workOrdersPartnerControllerGetWorkOrderDetailResponse403 | workOrdersPartnerControllerGetWorkOrderDetailResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerGetWorkOrderDetailResponse = (workOrdersPartnerControllerGetWorkOrderDetailResponseSuccess | workOrdersPartnerControllerGetWorkOrderDetailResponseError)

export const getWorkOrdersPartnerControllerGetWorkOrderDetailUrl = (workOrderId: string,) => {




  return `/work-orders/${workOrderId}`
}

/**
 * Read-only detail for one work order: identity, product / project / route context, dimensional + location metadata, current-vs-latest Bill of Operations version, job-card progress, scheduled vs actual timing, production lead days, and taggings. Backs the Neo Work Order Detail page.
 * @summary Get a single work order detail
 */
export const workOrdersPartnerControllerGetWorkOrderDetail = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerGetWorkOrderDetailResponse> => {

  return customFetch<workOrdersPartnerControllerGetWorkOrderDetailResponse>(getWorkOrdersPartnerControllerGetWorkOrderDetailUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkOrdersPartnerControllerGetWorkOrderDetailQueryKey = (workOrderId: string,) => {
    return [
    `/work-orders/${workOrderId}`
    ] as const;
    }


export const getWorkOrdersPartnerControllerGetWorkOrderDetailQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerGetWorkOrderDetailQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>> = ({ signal }) => workOrdersPartnerControllerGetWorkOrderDetail(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerGetWorkOrderDetailQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>>
export type WorkOrdersPartnerControllerGetWorkOrderDetailQueryError = void


export function useWorkOrdersPartnerControllerGetWorkOrderDetail<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerGetWorkOrderDetail<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerGetWorkOrderDetail<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single work order detail
 */

export function useWorkOrdersPartnerControllerGetWorkOrderDetail<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerGetWorkOrderDetailQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single work order detail
 */
export const prefetchWorkOrdersPartnerControllerGetWorkOrderDetailQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 queryClient: QueryClient, workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerGetWorkOrderDetailQueryOptions(workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkOrdersPartnerControllerGetWorkOrderDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerGetWorkOrderDetailQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>> = ({ signal }) => workOrdersPartnerControllerGetWorkOrderDetail(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerGetWorkOrderDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>>
export type WorkOrdersPartnerControllerGetWorkOrderDetailSuspenseQueryError = void


export function useWorkOrdersPartnerControllerGetWorkOrderDetailSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerGetWorkOrderDetailSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerGetWorkOrderDetailSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single work order detail
 */

export function useWorkOrdersPartnerControllerGetWorkOrderDetailSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerGetWorkOrderDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerGetWorkOrderDetailSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workOrdersPartnerControllerListDrawingsResponse200 = {
  data: WorkOrderDrawingRowDto[]
  status: 200
}

export type workOrdersPartnerControllerListDrawingsResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerListDrawingsResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerListDrawingsResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerListDrawingsResponseSuccess = (workOrdersPartnerControllerListDrawingsResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerListDrawingsResponseError = (workOrdersPartnerControllerListDrawingsResponse401 | workOrdersPartnerControllerListDrawingsResponse403 | workOrdersPartnerControllerListDrawingsResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerListDrawingsResponse = (workOrdersPartnerControllerListDrawingsResponseSuccess | workOrdersPartnerControllerListDrawingsResponseError)

export const getWorkOrdersPartnerControllerListDrawingsUrl = (workOrderId: string,) => {




  return `/work-orders/${workOrderId}/drawings`
}

/**
 * Returns the latest-revision drawings linked to the work order, enriched with the associated product name and the profiles that created / last updated each drawing, ordered by drawing name. Used by the Work Order Detail page "Drawings" tab.
 * @summary List a work order's drawings
 */
export const workOrdersPartnerControllerListDrawings = async (workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerListDrawingsResponse> => {

  return customFetch<workOrdersPartnerControllerListDrawingsResponse>(getWorkOrdersPartnerControllerListDrawingsUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkOrdersPartnerControllerListDrawingsQueryKey = (workOrderId: string,) => {
    return [
    `/work-orders/${workOrderId}/drawings`
    ] as const;
    }


export const getWorkOrdersPartnerControllerListDrawingsQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListDrawingsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>> = ({ signal }) => workOrdersPartnerControllerListDrawings(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListDrawingsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>>
export type WorkOrdersPartnerControllerListDrawingsQueryError = void


export function useWorkOrdersPartnerControllerListDrawings<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListDrawings<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListDrawings<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a work order's drawings
 */

export function useWorkOrdersPartnerControllerListDrawings<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListDrawingsQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List a work order's drawings
 */
export const prefetchWorkOrdersPartnerControllerListDrawingsQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 queryClient: QueryClient, workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerListDrawingsQueryOptions(workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkOrdersPartnerControllerListDrawingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListDrawingsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>> = ({ signal }) => workOrdersPartnerControllerListDrawings(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrdersPartnerControllerListDrawingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>>
export type WorkOrdersPartnerControllerListDrawingsSuspenseQueryError = void


export function useWorkOrdersPartnerControllerListDrawingsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListDrawingsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrdersPartnerControllerListDrawingsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a work order's drawings
 */

export function useWorkOrdersPartnerControllerListDrawingsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListDrawings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrdersPartnerControllerListDrawingsSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workOrdersPartnerControllerUploadDrawingResponse201 = {
  data: WorkOrderDrawingRowDto
  status: 201
}

export type workOrdersPartnerControllerUploadDrawingResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerUploadDrawingResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerUploadDrawingResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerUploadDrawingResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerUploadDrawingResponseSuccess = (workOrdersPartnerControllerUploadDrawingResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerUploadDrawingResponseError = (workOrdersPartnerControllerUploadDrawingResponse400 | workOrdersPartnerControllerUploadDrawingResponse401 | workOrdersPartnerControllerUploadDrawingResponse403 | workOrdersPartnerControllerUploadDrawingResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerUploadDrawingResponse = (workOrdersPartnerControllerUploadDrawingResponseSuccess | workOrdersPartnerControllerUploadDrawingResponseError)

export const getWorkOrdersPartnerControllerUploadDrawingUrl = (workOrderId: string,) => {




  return `/work-orders/${workOrderId}/drawings`
}

/**
 * Accepts one PDF (≤30 MB) plus an operation category and creates a drawing linked to this work order, through the same code path the bulk ZIP uploader uses — so the result is identical to a drawing that arrived in an archive. Everything except the file and the category is inferred from the work order: partner, project, the composed `{work order}+{category}+{file name}` drawing name, the storage path, and the uploading user. Thumbnails and the LLM-derived revision are generated asynchronously, so the returned row has revision "1" and no thumbnail yet. Re-uploading a file that composes to an existing drawing name supersedes that drawing's revision rather than duplicating it. The work order id comes from the path because guards run before the multipart body is parsed.
 * @summary Upload a single drawing to a work order
 */
export const workOrdersPartnerControllerUploadDrawing = async (workOrderId: string,
    workOrderDrawingUploadDto: WorkOrderDrawingUploadDto, options?: Parameters<typeof customFetch>[1]): Promise<workOrdersPartnerControllerUploadDrawingResponse> => {
    const formData = new FormData();
formData.append(`operation_category`, workOrderDrawingUploadDto.operation_category);

  return customFetch<workOrdersPartnerControllerUploadDrawingResponse>(getWorkOrdersPartnerControllerUploadDrawingUrl(workOrderId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getWorkOrdersPartnerControllerUploadDrawingMutationKey = () => ['workOrdersPartnerControllerUploadDrawing'] as const;

export const getWorkOrdersPartnerControllerUploadDrawingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>, TError,WorkOrdersPartnerControllerUploadDrawingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>, TError,WorkOrdersPartnerControllerUploadDrawingMutationVariables, TContext> => {

const mutationKey = getWorkOrdersPartnerControllerUploadDrawingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>, WorkOrdersPartnerControllerUploadDrawingMutationVariables> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  workOrdersPartnerControllerUploadDrawing(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerUploadDrawingMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>>
    export type WorkOrdersPartnerControllerUploadDrawingMutationBody = WorkOrderDrawingUploadDto
    export type WorkOrdersPartnerControllerUploadDrawingMutationError = void
    export type WorkOrdersPartnerControllerUploadDrawingMutationVariables = {workOrderId: string;data: WorkOrderDrawingUploadDto}

    /**
 * @summary Upload a single drawing to a work order
 */
export const useWorkOrdersPartnerControllerUploadDrawing = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>, TError,WorkOrdersPartnerControllerUploadDrawingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerUploadDrawing>>,
        TError,
        WorkOrdersPartnerControllerUploadDrawingMutationVariables,
        TContext
      > => {
      return useMutation(getWorkOrdersPartnerControllerUploadDrawingMutationOptions(options), queryClient);
    }
    export type setRouteControllerSetRouteResponse201 = {
  data: SetRouteResponseDto
  status: 201
}

export type setRouteControllerSetRouteResponse400 = {
  data: void
  status: 400
}

export type setRouteControllerSetRouteResponse401 = {
  data: void
  status: 401
}

export type setRouteControllerSetRouteResponse403 = {
  data: void
  status: 403
}

export type setRouteControllerSetRouteResponse404 = {
  data: void
  status: 404
}

export type setRouteControllerSetRouteResponse409 = {
  data: void
  status: 409
}

export type setRouteControllerSetRouteResponseSuccess = (setRouteControllerSetRouteResponse201) & {
  headers: Headers;
};
export type setRouteControllerSetRouteResponseError = (setRouteControllerSetRouteResponse400 | setRouteControllerSetRouteResponse401 | setRouteControllerSetRouteResponse403 | setRouteControllerSetRouteResponse404 | setRouteControllerSetRouteResponse409) & {
  headers: Headers;
};

export type setRouteControllerSetRouteResponse = (setRouteControllerSetRouteResponseSuccess | setRouteControllerSetRouteResponseError)

export const getSetRouteControllerSetRouteUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/work-orders/set-route`
}

/**
 * ENG-743: applies the route — and, because the route drives the factory, the route’s factory (both factory_id and the legacy scheduled-factory-name column) — to every ELIGIBLE work order in the selection, in one transaction. Eligible = Scheduled and not archived; locked rows (draft / redrafting / in_progress / complete) and archived rows are silently removed from the action and returned under `skipped` with a reason (spec §17.4). The route must be active, its factory unarchived, and it must support the product type of EVERY eligible work order — otherwise the whole action fails with 400 code ROUTE_PRODUCT_TYPE_UNSUPPORTED listing the offending work orders. Each applied work order gets an audit event recording the route and factory change.
 * @summary Set a route on the selected work orders (bulk)
 */
export const setRouteControllerSetRoute = async (partnerId: string,
    setRouteRequestDto: SetRouteRequestDto, options?: Parameters<typeof customFetch>[1]): Promise<setRouteControllerSetRouteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setRouteControllerSetRouteResponse>(getSetRouteControllerSetRouteUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setRouteRequestDto)
  }
);}





export const getSetRouteControllerSetRouteMutationKey = () => ['setRouteControllerSetRoute'] as const;

export const getSetRouteControllerSetRouteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRouteControllerSetRoute>>, TError,SetRouteControllerSetRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setRouteControllerSetRoute>>, TError,SetRouteControllerSetRouteMutationVariables, TContext> => {

const mutationKey = getSetRouteControllerSetRouteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRouteControllerSetRoute>>, SetRouteControllerSetRouteMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  setRouteControllerSetRoute(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetRouteControllerSetRouteMutationResult = NonNullable<Awaited<ReturnType<typeof setRouteControllerSetRoute>>>
    export type SetRouteControllerSetRouteMutationBody = SetRouteRequestDto
    export type SetRouteControllerSetRouteMutationError = void
    export type SetRouteControllerSetRouteMutationVariables = {partnerId: string;data: SetRouteRequestDto}

    /**
 * @summary Set a route on the selected work orders (bulk)
 */
export const useSetRouteControllerSetRoute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRouteControllerSetRoute>>, TError,SetRouteControllerSetRouteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setRouteControllerSetRoute>>,
        TError,
        SetRouteControllerSetRouteMutationVariables,
        TContext
      > => {
      return useMutation(getSetRouteControllerSetRouteMutationOptions(options), queryClient);
    }
